import { render, staticRenderFns } from "./ActionConfigsForm.vue?vue&type=template&id=1a23d472&"
import script from "./ActionConfigsForm.vue?vue&type=script&lang=js&"
export * from "./ActionConfigsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports